/**
 * The studio's own facts. Edit this file to make the site yours: everything here is data, not
 * copy, so it stays out of the translation catalog. Coaches, sessions, prices and open times are
 * not here either. They come live from the booking pack (Setup in the app), so the site can
 * never disagree with the calendar.
 */
export const siteConfig = {
  phone: "+48 12 555 01 44",
  /** The same number in the form a `tel:` link wants. */
  phoneHref: "tel:+48125550144",
  email: "hello@streak.coach",
  address: "Zabłocie 23, Kraków",
  /** Opens the address in a maps app. */
  mapUrl: "https://www.openstreetmap.org/search?query=Zab%C5%82ocie%2023%2C%20Krak%C3%B3w",
  /** Opening hours as the site prints them. `null` means closed that day. */
  hours: {
    weekdays: "7:00 to 21:00",
    saturday: "9:00 to 14:00",
    sunday: null as string | null,
  },
  /** The numbers on the home page. Keep them true. */
  stats: {
    sessionsCoached: "12k",
    since: "2016",
    rebookRate: "94%",
    rating: "4.9",
    reviewCount: "312",
    /** Share of reviews per star, five first. Draws the bars next to the rating. */
    ratingShares: [0.92, 0.06, 0.02, 0, 0],
  },
  /** How many days of open times the public calendar shows at once. */
  calendarDays: 5,
} as const;
